import { render, staticRenderFns } from "./UploadChk.vue?vue&type=template&id=22df68bb&scoped=true&"
import script from "./UploadChk.vue?vue&type=script&lang=js&"
export * from "./UploadChk.vue?vue&type=script&lang=js&"
import style0 from "./UploadChk.vue?vue&type=style&index=0&id=22df68bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22df68bb",
  null
  
)

export default component.exports